import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Foros } from '../../../models/obs/foros';
import { urlEndPoint } from 'src/app/common';
import { ForosService } from 'src/app/services/obs/foros.service';

@Component({
  selector: 'app-foro-detalle',
  templateUrl: './foro-detalle.component.html',
  styleUrl: './foro-detalle.component.scss'
})
export class ForoDetalleComponent implements OnInit {
  foroDetalle: Foros;
  safeUrls: SafeResourceUrl[] = []; // Nueva propiedad para la URL segura
  URL: string = urlEndPoint;

  constructor(private route: ActivatedRoute, private forosService: ForosService, private sanitizer: DomSanitizer) {
    this.foroDetalle = {} as Foros;
  }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');

    this.forosService.getForoDetalle(id).subscribe(
      (response: any) => {
        if (response && response.data) {
          this.foroDetalle = response.data;
          // Use DomSanitizer to mark each URL in the array as safe
          this.safeUrls = this.foroDetalle.urls.map(url => this.sanitizer.bypassSecurityTrustResourceUrl(url));
          /*    console.log("Estos son las urls:" + this.safeUrls) */
        } else {
          console.error('Respuesta del servicio sin datos válidos:', response);
        }
      },
      (error: any) => {
        console.error('Error al obtener el detalle del foro:', error);
      }
    );
  }

  getParagraphs(description: string): string[] {
    if (description) {
      // Divide el texto en párrafos separados por "\r\n".
      return description.split(/\r\n/);
    }
    return [];
  }
}


